import get from 'lodash';

const selectFilterValues = (entityType) => (store) => get(store, `entity.${entityType}.filterValues`, {});

export default selectFilterValues;
